export const DEFAULT_SUBFLOW = 'main';
export const DEFAULT_REVISION_NAME = 'Default';
